<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF BUSINESS MANAGEMENT & COMMERCE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Commerce</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Post Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Commerce</td>
                            <td class="time">Master of Commerce</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Bachelor of Commerce</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Commerce (BCom) </b>
                    – The three-year undergraduate Bachelor of Commerce program at the ARNI School of Business
                    Management & Commerce teaches students the fundamentals of business, finance, and commerce. The
                    course provides a thorough understanding of business processes and principles by covering topics
                    such as accounting, economics, business law, taxes, and financial management.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Foundations</p>
                <ul>
                    <li>English Communications</li>
                    <li> Business Organization and Management (BOM)</li>
                    <li>Environmental Studies</li>
                    <li>Financial Accounting</li>
                    <li> Business Mathematics</li>
                    <li> Business Economics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Core Concepts</p>
                <ul>
                    <li>English Communications</li>
                    <li> Indian Financial System</li>
                    <li> Fundamentals of Entrepreneurship</li>
                    <li> Business Law</li>
                    <li> Business Mathematics and Statistics</li>
                    <li> Corporate Accounting</li>
                    <li> Hindi/ Modern Indian Language</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : Fundamentals</p>
                <ul>
                    <li> Income Tax Law and Practice</li>
                    <li> Corporate Accounting – II</li>
                    <li> Marketing Management</li>
                    <li> Business Economics – II</li>
                    <li> Fundamentals of Auditing</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> : Business Strategy</p>
                <ul>
                    <li> Industrial Laws</li>
                    <li> Business Statistics – II</li>
                    <li> E-Commerce</li>
                    <li> Cost Accounting</li>
                    <li> Management Accounting</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b> : Industry Specialization
                </p>
                <ul>
                    <li> Cost & Management Accounting</li>
                    <li> Indian Financial System</li>
                    <li> Goods & Services Tax</li>
                    <li> Indirect Tax Law</li>
                    <li> HR Management & Entrepreneurship</li>
                    <li> Principles of Micro Economics</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b> : Career Readiness
                </p>
                <ul>
                    <li> Banking and Insurance</li>
                    <li> Computerized Accounting System</li>
                    <li> Office Management and Secretarial Practice</li>
                    <li> Business Investment</li>
                    <li> E-Commerce & Digital Transformation</li>
                    <li> Elective II</li>
                    <li> Project/Internship</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Commerce (MCom) </b> –
                    The ARNI School of Business Management & Commerce offers a two-year postgraduate Bachelor of
                    Commerce degree that teaches students specific postgraduate courses in banking, insurance, finance,
                    economics, and other relevant areas of the commerce industry. By addressing subjects including
                    accounting, economics, business law, taxes, and financial management, the course offers a
                    comprehensive grasp of business processes and principles.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Foundations
                </p>
                <ul>
                    <li>Organizational Behavior and Management Process</li>
                    <li> Corporate Governance</li>
                    <li>Managerial Economics</li>
                    <li>Indian Financial System</li>
                    <li>Paper/course</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Core Concepts
                </p>
                <ul>
                    <li> Research Methodology</li>
                    <li> Cooperation</li>
                    <li> Management of Nonprofit Organizations</li>
                    <li> Management and Financial Accounting</li>
                    <li> Research/Project</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : Fundamentals
                </p>
                <ul>
                    <li> Managerial Communication</li>
                    <li> Advanced Management Accounting</li>
                    <li> Statistical Techniques</li>
                    <li> Research/Project</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> : Business Strategy
                </p>
                <ul>
                    <li> International Business Environment</li>
                    <li> Core Group</li>
                    <li> Mergers & Acquisitions</li>
                    <li> Research/Project</li>
                </ul>
            </div>


        </div>

    </div>
</section>
